import { AppDispatch } from "..";
import { podActions } from "../slices/PODSlice";
import { fetchPOD } from "../../services/pods";

export const getPODData = (id: string) => {
  return async (dispatch: AppDispatch) => {
    fetchPOD(id)
      .then((res) => {
        if (res.status === 200) {
          const data = res.data;
          dispatch(podActions.getPOD(data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
};
